module.exports = __webpack_public_path__ + "img/2.a711aa45.png";